import { render, staticRenderFns } from "./widget-add-report.vue?vue&type=template&id=5d594c30&"
import script from "./widget-add-report.vue?vue&type=script&lang=js&"
export * from "./widget-add-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports